import React from 'react';
import createContext from '../../context';

const { ContextProvider, ContextConsumer } = createContext({ cardType: 'card' });

export const GigCardContextProvider = ({ value, children }) => (
    <ContextProvider value={value}>
        {children}
    </ContextProvider>
);

export const withGigCardContext = (selector) => (Wrapped) => (props) => (
    <ContextConsumer>{(context) => (<Wrapped {...selector(context)} {...props}/>)}</ContextConsumer>
);



// WEBPACK FOOTER //
// ./src/shared/gig_card_context/index.js